import { action } from 'satcheljs';

export let onListViewSelectionChangeComplete = action('ON_LISTVIEW_SELECTION_CHANGE_COMPLETE');
